import React from 'react';

export const TabViewContext = React.createContext(0);
